import React from 'react';
import Features from './Features';
import Advantages from './Advantages';
import { FAQ } from '../FAQ/faqs';
import Footer from '../Footer';



function DocumentAutomation() {
  return (
    <>
<Features docname="Document Automation and Management"/>
<Advantages docname="Document Automation and Management"/>
<FAQ category="About Accxchange"/>
<Footer segment="Smarty Home"/>
    </>
  );
}

export default DocumentAutomation;

